var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Logo from '../../../Logo';
const LogoDiners = (_a) => {
    var commonProps = __rest(_a, []);
    const source = {
        content: (React.createElement("svg", { width: 48, height: 32, viewBox: "0 0 48 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.4189 16.1727C12.4189 10.8404 16.7415 6.51782 22.0735 6.51782C27.4058 6.51782 31.7284 10.8404 31.7284 16.1727C31.7284 21.505 27.4058 25.8278 22.0735 25.8278C16.7415 25.8278 12.4189 21.505 12.4189 16.1727Z", fill: "#FFFFFE" }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27.9124 15.9825C27.9085 13.51 26.3631 11.4014 24.1854 10.5663V21.3983C26.3631 20.5621 27.9085 18.4554 27.9124 15.9825ZM20.0311 21.3961V10.5674C17.8553 11.405 16.3122 13.5107 16.3064 15.9825C16.3122 18.4537 17.8553 20.5591 20.0311 21.3961ZM22.1093 6.82694C17.053 6.82888 12.9565 10.9262 12.9556 15.9825C12.9565 21.0382 17.053 25.1349 22.1093 25.1357C27.1656 25.1349 31.2629 21.0382 31.2642 15.9825C31.2629 10.9262 27.1656 6.82888 22.1093 6.82694ZM22.0869 25.9999C16.5539 26.0262 12 21.5437 12 16.0871C12 10.1237 16.5539 5.99892 22.0869 6H24.6798C30.1474 5.99892 35.1374 10.1217 35.1374 16.0871C35.1374 21.5418 30.1474 25.9999 24.6798 25.9999H22.0869Z", fill: "#184977" }))),
        alt: 'Diners',
    };
    return React.createElement(Logo, Object.assign({}, commonProps, { source: source }));
};
export default LogoDiners;
//# sourceMappingURL=index.js.map